<div class="am-flex-column am-flex-1 bg-white overflow relative">
  <div #chatBox class="am-flex-column am-flex-1 gap-xxs p-s overflow-auto bg-grey"
       [class.hide]="!loaded"
        infiniteScroll
       [infiniteScrollDistance]="1"
       [infiniteScrollThrottle]="150"
       [scrollWindow]="false"
       (scrolledUp)="loadMessagesHandler()"
       (scroll)="onScroll()">
    @for (message of messages; track message.id; let i = $index) {
      @if (showDate(message, i)) { <span class="am-flex-center p-xs font-s font-500">{{ getDateTitle(message) }}</span> }
      <chat-box-message #message
                        [chatFullAccess]="chatFullAccess"
                        [message]="message"
                        [prevMessage]="messages[i-1]"
                        [nextMessage]="messages[i+1]"
                        [index]="i"
                        [showDate]="showDate(message, i)"
                        [editMode]="editMode === message.id && editMode"
                        [myId]="meParticipant?.id"
                        [ownerId]="owner.id"
                        [participantName]="getName(message.participantId)"

                        (edit)="updateMessageHandler($event)"
                        (delete)="deleteMessage($event)">
      </chat-box-message>
    }
    <chat-typing [myId]="meParticipant?.id" [roomId]="room.id" [getParticipantByIdFn]="getParticipantByIdFn"></chat-typing>
  </div>

  <div class="am-flex-justify gap-s p-s bt-grey">
    <input type="text" class="placeholder-primary-grey width-full border-focus-blue animate-border" (focus)="active = true" [(ngModel)]="messageInput" (ngModelChange)="meTypingHandler()" placeholder="Geben Sie hier Ihre Nachricht ein">
    <div class="am-flex-center bg-blue b-radius p-xxs color-white icon-send font-icon" (click)="submit()"></div>
  </div>
  @if (loading) {
    <div class="absolute-full bg-overlay-white events-none wait-animation">
      <div class="am-flex-center">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  }
</div>
